<template>
  <div class="sv-wrapper">
    <!-- ── Cuerpo ── -->
    <div class="sv-body">
      <!-- ── Panel de estado de encendido ── -->
      <div class="sv-power-panel" v-if="activerecorders.length > 0">
        <div class="sv-power-panel__header">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path
              d="M18.36 6.64a9 9 0 11-12.73 0"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              fill="none"
            />
            <line
              x1="12"
              y1="2"
              x2="12"
              y2="12"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          <span class="sv-power-panel__title">Estado de encendido</span>
          <span class="sv-power-panel__subtitle"
            >Señal en los últimos 10 min</span
          >
          <div class="sv-power-panel__counters">
            <span class="sv-power-counter sv-power-counter--on">
              <span
                class="sv-power-counter__dot sv-power-counter__dot--on"
              ></span>
              {{ onlineCount }} encendidas
            </span>
            <span class="sv-power-counter sv-power-counter--off">
              <span
                class="sv-power-counter__dot sv-power-counter__dot--off"
              ></span>
              {{ offlineCount }} apagadas
            </span>
            <span
              v-if="unknownCount > 0"
              class="sv-power-counter sv-power-counter--unknown"
            >
              <span
                class="sv-power-counter__dot sv-power-counter__dot--unknown"
              ></span>
              {{ unknownCount }} sin datos
            </span>
          </div>
        </div>
        <div class="sv-power-grid">
          <div
            v-for="recorder in nonAxisRecorders"
            :key="recorder.identifier"
            class="sv-power-chip"
            :class="powerClass(recorder.identifier)"
            :title="powerTooltip(recorder.identifier)"
          >
            <span class="sv-power-chip__dot"></span>
            <span class="sv-power-chip__name">{{
              recorder.name || recorder.identifier
            }}</span>
            <span class="sv-power-chip__time">{{
              powerTime(recorder.identifier)
            }}</span>
          </div>
        </div>
      </div>

      <!-- ── Panel de edición ── -->
      <transition name="sv-slide">
        <div
          v-if="showForm"
          class="sv-form-overlay"
          @click.self="showForm = false"
        >
          <div class="sv-form-panel">
            <div class="sv-form-panel__header">
              <div class="sv-form-panel__title">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="#0284C7"
                    stroke-width="2"
                    fill="none"
                  />
                  <path
                    d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"
                    stroke="#0284C7"
                    stroke-width="2"
                    fill="none"
                  />
                </svg>
                Gestionar cámara
              </div>
              <span class="sv-form-panel__cam">{{
                selectedrecorderIdentifier
              }}</span>
              <button class="sv-form-panel__close" @click="showForm = false">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <line
                    x1="18"
                    y1="6"
                    x2="6"
                    y2="18"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <line
                    x1="6"
                    y1="6"
                    x2="18"
                    y2="18"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>

            <div class="sv-form-panel__body">
              <el-form :model="formData" class="sv-form">
                <div class="sv-form-field">
                  <label class="sv-form-field__label">Nombre asignado</label>
                  <el-input
                    v-model="formData.nombre"
                    class="sv-input"
                    placeholder="Asignar nombre a esta cámara"
                  />
                </div>
              </el-form>
            </div>

            <div class="sv-form-panel__footer">
              <button
                class="sv-btn sv-btn--secondary"
                @click="showForm = false"
              >
                Cancelar
              </button>
              <button class="sv-btn sv-btn--danger" @click="onDelete">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <polyline
                    points="3,6 5,6 21,6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M19 6l-1 14H6L5 6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10 11v6M14 11v6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M9 6V4h6v2"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                Eliminar
              </button>
              <button class="sv-btn sv-btn--primary" @click="onConfirm">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <polyline
                    points="20,6 9,17 4,12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    fill="none"
                  />
                </svg>
                Guardar
              </button>
            </div>
          </div>
        </div>
      </transition>

      <!-- ── Preview de imagen ── -->
      <transition name="sv-fade">
        <div
          v-if="previewImage"
          class="sv-preview-overlay"
          @click="previewImage = null"
        >
          <button class="sv-preview-close" @click="previewImage = null">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <line
                x1="18"
                y1="6"
                x2="6"
                y2="18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <line
                x1="6"
                y1="6"
                x2="18"
                y2="18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>
          <img
            :src="previewImage"
            alt="Preview"
            class="sv-preview-img"
            @click.stop
          />
        </div>
      </transition>

      <!-- ── Grid de cámaras ── -->
      <div class="sv-grid">
        <RecorderImage
          v-for="(recorder, index) in activerecorders"
          :key="recorder.identifier"
          :name="recorder"
          :status="status[index]"
          @select="previewImage = $event"
          @settings="openrecorderSettings"
          @load-error="onRecorderLoadError"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RecorderImage from "./RecorderImage.vue";
import {
  loadrecorders,
  loadStatus,
  updaterecorder,
  deleterecorder,
  loadHeartbeats,
} from "@/services/supervisor.api";

const POWER_THRESHOLD_MS = 10 * 60 * 1000; // 10 minutos

export default {
  name: "SupervisorView",
  components: { RecorderImage },
  data() {
    return {
      recorders: [],
      isLoading: false,
      previewImage: null,
      isZoomed: false,
      status: [],
      showForm: false,
      formData: {
        selectedrecorder: null,
        nombre: "",
      },
      // identifier -> Date
      heartbeats: {},
      loadErrors: [],
    };
  },
  computed: {
    activerecorders() {
      return this.recorders.filter((recorder) => !recorder.isDeleted);
    },
    nonAxisRecorders() {
      return this.activerecorders.filter((r) => !r.isAxis);
    },
    onlineCount() {
      return this.nonAxisRecorders.filter((r) => {
        const ts = this.heartbeats[r.identifier];
        if (!ts) return false;
        return Date.now() - ts.getTime() <= POWER_THRESHOLD_MS;
      }).length;
    },
    offlineCount() {
      return this.nonAxisRecorders.filter((r) => {
        const ts = this.heartbeats[r.identifier];
        if (!ts) return false;
        return Date.now() - ts.getTime() > POWER_THRESHOLD_MS;
      }).length;
    },
    unknownCount() {
      return this.nonAxisRecorders.filter((r) => !this.heartbeats[r.identifier])
        .length;
    },
  },
  async created() {
    this.isLoading = true;
    try {
      this.recorders = await loadrecorders();
      this.status = await loadStatus();
      const heartbeatData = await loadHeartbeats();
      heartbeatData.forEach(({ identifier, loggedAt }) => {
        this.$set(
          this.heartbeats,
          identifier,
          loggedAt ? new Date(loggedAt) : null
        );
      });
    } catch (e) {
      this.$message.error("Error al cargar las cámaras");
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    powerClass(identifier) {
      const ts = this.heartbeats[identifier];
      if (!ts) return "sv-power-chip--unknown";
      const diff = Date.now() - ts.getTime();
      return diff <= POWER_THRESHOLD_MS
        ? "sv-power-chip--on"
        : "sv-power-chip--off";
    },
    powerTime(identifier) {
      const ts = this.heartbeats[identifier];
      if (!ts) return "—";
      const diffMin = Math.floor((Date.now() - ts.getTime()) / 60000);
      if (diffMin < 1) return "Ahora";
      if (diffMin < 60) return `hace ${diffMin} min`;
      const diffH = Math.floor(diffMin / 60);
      if (diffH < 24) return `hace ${diffH} h`;
      const diffD = Math.floor(diffH / 24);
      if (diffD === 1) return "ayer";
      if (diffD < 7) return `hace ${diffD} días`;
      return ts.toLocaleDateString("es-ES", { day: "numeric", month: "short" });
    },
    onRecorderLoadError(identifier) {
      this.loadErrors.push(identifier);
      clearTimeout(this._errorTimer);
      this._errorTimer = setTimeout(() => {
        if (this.loadErrors.length === 1) {
          this.$message.error(
            `Fallo de conexión con cámara: ${this.loadErrors[0]}`
          );
        } else {
          this.$message.error(
            `Fallo de conexión con cámaras: ${this.loadErrors.join(", ")}`
          );
        }
        this.loadErrors = [];
      }, 1500);
    },
    powerTooltip(identifier) {
      const ts = this.heartbeats[identifier];
      if (!ts) return "Sin datos de señal";
      return `Última señal: ${ts.toLocaleString("es-ES", {
        dateStyle: "medium",
        timeStyle: "short",
      })}`;
    },
    openrecorderSettings(recorder) {
      this.showForm = true;
      this.previewImage = null;
      this.isZoomed = false;
      this.formData.selectedrecorder = recorder.id;
      this.formData.nombre = recorder.name || "";
      this.selectedrecorderIdentifier = recorder.identifier;
    },
    async onDelete() {
      try {
        await this.$confirm(
          `¿Estás seguro de que quieres eliminar la carretilla ${this.selectedrecorderIdentifier}?`,
          "Confirmar eliminación",
          {
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        );
        await deleterecorder(this.selectedrecorderIdentifier);
        this.$message.success("Carretilla eliminada correctamente");
        this.showForm = false;
        this.formData.selectedrecorder = null;
        this.formData.nombre = "";
        this.selectedrecorderIdentifier = "";
        this.recorders = await loadrecorders();
        this.status = await loadStatus();
      } catch (e) {
        if (e === "cancel") {
          return;
        }
        if (e.response && e.response.status === 400) {
          this.$message.error("No se puede eliminar esta carretilla");
        } else {
          this.$message.error("Error al eliminar la carretilla");
        }
      }
    },
    toggleZoom() {
      this.isZoomed = !this.isZoomed;
    },
    updaterecorderName() {
      this.showForm = true;
      this.previewImage = null;
      this.isZoomed = false;
    },
    async onConfirm() {
      try {
        await updaterecorder(
          this.formData.selectedrecorder,
          this.formData.nombre
        );
        this.$message.success("recorder actualizada correctamente");
        this.showForm = false;
        this.formData.selectedrecorder = null;
        this.formData.nombre = "";
        this.recorders = await loadrecorders();
      } catch (e) {
        if (e.response && e.response.status === 400) {
          this.$message.error(
            "Ese nombre ya está siendo utilizado por otra carretilla"
          );
        } else {
          this.$message.error("Error al actualizar la recorder");
        }
      }
    },
    onrecorderSelect(recorderId) {
      const selectedrecorder = this.recorders.find((f) => f.id === recorderId);
      if (selectedrecorder) {
        this.formData.nombre = selectedrecorder.name || "";
      }
    },
    cancelForm() {
      this.showForm = false;
      this.formData.selectedrecorder = null;
      this.formData.nombre = "";
    },
  },
};
</script>

<style>
/* ── Wrapper ──────────────────────────────────────────────────── */
.sv-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: #f0f4f8;
  animation: svFadeIn 0.25s ease;
}
@keyframes svFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* ── Body ─────────────────────────────────────────────────────── */
.sv-body {
  flex: 1;
  overflow: auto;
  padding: 22px 24px;
  position: relative;
}

/* ── Power panel ──────────────────────────────────────────────── */
.sv-power-panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  padding: 14px 18px 16px;
  margin-bottom: 20px;
}

.sv-power-panel__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  color: #0f172a;
}

.sv-power-panel__title {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.sv-power-panel__subtitle {
  font-size: 11px;
  color: #94a3b8;
  flex: 1;
}

.sv-power-panel__counters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.sv-power-counter {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 500;
}

.sv-power-counter--on {
  color: #16a34a;
}
.sv-power-counter--off {
  color: #ef4444;
}
.sv-power-counter--unknown {
  color: #94a3b8;
}

.sv-power-counter__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}
.sv-power-counter__dot--on {
  background: #22c55e;
}
.sv-power-counter__dot--off {
  background: #ef4444;
}
.sv-power-counter__dot--unknown {
  background: #cbd5e1;
}

/* ── Power grid (chips) ───────────────────────────────────────── */
.sv-power-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.sv-power-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 20px;
  border: 1px solid;
  font-size: 12px;
  font-weight: 500;
  cursor: default;
  transition: opacity 0.15s;
}
.sv-power-chip:hover {
  opacity: 0.8;
}

.sv-power-chip--on {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #15803d;
}
.sv-power-chip--off {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}
.sv-power-chip--unknown {
  background: #f8fafc;
  border-color: #e2e8f0;
  color: #94a3b8;
}

.sv-power-chip__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}
.sv-power-chip--on .sv-power-chip__dot {
  background: #22c55e;
  animation: svPowerPulse 2s ease infinite;
}
.sv-power-chip--off .sv-power-chip__dot {
  background: #ef4444;
}
.sv-power-chip--unknown .sv-power-chip__dot {
  background: #cbd5e1;
}
@keyframes svPowerPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}

.sv-power-chip__name {
  white-space: nowrap;
}

.sv-power-chip__time {
  font-size: 10px;
  opacity: 0.7;
  white-space: nowrap;
}

/* ── Grid ─────────────────────────────────────────────────────── */
.sv-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 18px;
}

/* ── Form overlay (modal centrado) ────────────────────────────── */
.sv-form-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.sv-form-panel {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  width: 420px;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  animation: svSlideUp 0.2s ease;
}
@keyframes svSlideUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.sv-form-panel__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 12px 12px 0 0;
}

.sv-form-panel__title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  flex: 1;
}

.sv-form-panel__cam {
  font-size: 12px;
  color: #0284c7;
  font-weight: 600;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 2px 8px;
}

.sv-form-panel__close {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: border-color 0.15s, color 0.15s;
}
.sv-form-panel__close:hover {
  border-color: #94a3b8;
  color: #0f172a;
}

.sv-form-panel__body {
  padding: 24px 20px;
}

.sv-form-panel__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0 0 12px 12px;
}

/* ── Form field ───────────────────────────────────────────────── */
.sv-form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sv-form-field__label {
  font-size: 11px;
  font-weight: 600;
  color: #0284c7;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.sv-input .el-input__inner {
  border-color: #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #0f172a;
  height: 38px;
  transition: border-color 0.15s;
}
.sv-input .el-input__inner:focus {
  border-color: #0284c7;
}

/* ── Buttons ──────────────────────────────────────────────────── */
.sv-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 16px;
  border-radius: 8px;
  border: 1px solid;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  transition: opacity 0.15s, box-shadow 0.15s;
}
.sv-btn--secondary {
  background: #f8fafc;
  border-color: #e2e8f0;
  color: #64748b;
}
.sv-btn--secondary:hover {
  opacity: 0.8;
}

.sv-btn--primary {
  background: #0284c7;
  border-color: #0284c7;
  color: #fff;
  box-shadow: 0 2px 8px rgba(2, 132, 199, 0.3);
}
.sv-btn--primary:hover {
  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.45);
}

.sv-btn--danger {
  background: #fef2f2;
  border-color: #fca5a5;
  color: #ef4444;
}
.sv-btn--danger:hover {
  opacity: 0.85;
}

/* ── Preview overlay ──────────────────────────────────────────── */
.sv-preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sv-preview-img {
  max-width: 90vw;
  max-height: 88vh;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.6);
}

.sv-preview-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.sv-preview-close:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* ── Transitions ──────────────────────────────────────────────── */
.sv-slide-enter-active,
.sv-slide-leave-active {
  transition: opacity 0.2s;
}
.sv-slide-enter,
.sv-slide-leave-to {
  opacity: 0;
}
.sv-fade-enter-active,
.sv-fade-leave-active {
  transition: opacity 0.2s;
}
.sv-fade-enter,
.sv-fade-leave-to {
  opacity: 0;
}
</style>
